export const backgroundDesktopFirst =
  "https://static.igem.wiki/teams/4380/wiki/background/wiki-background-desktop-first.svg"

export const backgroundDesktopSecond =
  "https://static.igem.wiki/teams/4380/wiki/background/wiki-background-desktop-second.svg"

export const backgroundMobileFirst =
  "https://static.igem.wiki/teams/4380/wiki/background/wiki-background-phone-first.svg"

export const backgroundMobileSecond =
  "https://static.igem.wiki/teams/4380/wiki/background/wiki-background-phone-second.svg"

export const backgroundDesktopVeryLong =
  "https://static.igem.wiki/teams/4380/wiki/background/wiki-background-very-long-desktop.svg"

export const backgroundPhoneVeryLong =
  "https://static.igem.wiki/teams/4380/wiki/background/wiki-background-phone-very-long.svg"

export const backgroundDesktopLongest =
  "https://static.igem.wiki/teams/4380/wiki/background/longest-desktop-background.svg"
